<div class="teia-modal">
    <div class="td-cnt-ext">
        <div class="td-cnt-lg">
            <div class="td-cnt-title">
                <span class="te-title">{{ 'enquiryBook.customerSpecialRequirements' | translate}}</span>
            </div>
            <div class="td-cnt-body">
                <div class="list-container">
                    <div *ngFor="let csr of customerSpecialRequirements; let i = index; trackBy: trackByIndex"
                        class="requirement-row">
                        <div class="comments-grid">
                            <div class="cell">
                                <label>{{ 'grid.salesPersonComment' | translate }}</label>
                                <textarea class="same-height comment-field" rows="6" [readonly]="readOnly"
                                    [disabled]="readOnly" [value]="csr.salesPersonComment"
                                    (input)="onSalesPersonCommentInput($event, i)"
                                    [placeholder]="'grid.salesPersonComment' | translate"></textarea>
                            </div>

                            <div class="cell">
                                <label>{{ 'grid.millComment' | translate }}</label>
                                <textarea class="same-height comment-field" rows="6" readonly disabled
                                    [value]="csr.millComment" ></textarea>
                            </div>
                        </div>

                        <div class="meta-row">
                            <div class="meta-field meta-mill">
                                <label>{{ 'grid.Mill' | translate }}</label>
                                <div class="cell-control">
                                    <teiasoft-select [isMobile]="isMobile" [isRequired]="true" [disabled]="readOnly"
                                        [readOnly]="readOnly" [optionsList]="itdcrMillOptionList" [spaceLabel]="false"
                                        [noMinWidth]="true" [isValid]="readOnly || isItdcrMillSelected(csr)"
                                        [defaultValue]="csr.itdcrMillId" (onSelected)="onItdcrMillChange($event, i)">
                                    </teiasoft-select>
                                </div>
                            </div>

                            <label class="checkbox-field">
                                <span class="checkbox-label">{{ 'grid.IsCustomerRelevant' | translate }}</span>
                                <input type="checkbox" [checked]="csr.isCustomerRelevant" [disabled]="readOnly"
                                    (change)="onCustomerRelevantChange($event, i)" />
                            </label>

                            <div class="delete-wrap" *ngIf="!readOnly">
                                <button *ngIf="!readOnly" class="teia-tt-button tb-primary remove-btn "
                                    (click)="duplicateRequirement(i)">
                                    <i class="fal fa-clone"></i>
                                </button>
                                <button *ngIf="!readOnly" class="teia-tt-button tb-primary remove-btn" style="margin-left: 1rem;"
                                    (click)="removeRequirement(i)">
                                    <i class="fal fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Add new entry -->
                <div class="mt-3 add-row">
                    <teiasoft-button *ngIf="!readOnly" (onClick)="addRequirement()" [type]="'tb-primary'"
                        [text]="'commons.add' | translate" [disabled]="!canAdd"></teiasoft-button>
                </div>

            </div>
            <div class="td-cnt-btn">
                <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                    class="mr-5"></teiasoft-button>

                <teiasoft-button *ngIf="!readOnly" (onClick)="onSaveClick()" [type]="'tb-secondary'"
                    [text]="'commons.confirm' | translate" class="mr-5" [disabled]="!canSave"></teiasoft-button>
            </div>
        </div>

    </div>
</div>